// extracted by mini-css-extract-plugin
export default {"container":"Warehouse_container__qhRg2"};